import type { FunctionComponent } from 'react';
import { defineSlotComponent, findFirstForSlot } from '../layouts/slots';
import styles from './ReportViewer.module.less';

const FORMAT = 'format';
const CONTENT = 'content';

type ReportViewerComponent = FunctionComponent & {
  Format: FunctionComponent;
  Content: FunctionComponent;
};

const ReportViewer: ReportViewerComponent = ({ children }) => {
  const format = findFirstForSlot(FORMAT, children);
  const content = findFirstForSlot(CONTENT, children);

  return (
    <div className={styles.reportViewer}>
      {format}
      {content}
    </div>
  );
};

ReportViewer.Format = defineSlotComponent(FORMAT, ({ children }) => (
  <div className={styles.reportFormat}>{children}</div>
));

ReportViewer.Content = defineSlotComponent(CONTENT, ({ children }) => (
  <div className={styles.reportContent}>{children}</div>
));

export default ReportViewer;
